import React, { useContext } from "react"
import { Navigate } from "react-router-dom"
import { GlobalContext } from "../contexts/global"
import encryptClass from "../inc/Controllers/encrypt.class"

const ProtectedRoute = ({ children }) => {
  const { patientFound } = useContext(GlobalContext)
  let valid = false
  if (patientFound) {
    try {
      const parsed = JSON.parse(encryptClass.reveal(patientFound))
      valid = !!(parsed && parsed.id)
    } catch (_) {
      valid = false
    }
  }
  return valid ? children : <Navigate to="/" replace />
}

export default ProtectedRoute
